<div class="table-responsive table">

    <table mat-table [dataSource]="dataSource" matSort #tableSort="matSort">
        <ng-container *ngFor="let disCol of tableColumns let colIndex = index;trackBy:trackByFn"
            matColumnDef="{{disCol.columnDef}}">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ disCol.header }}
                <!-- <img *ngIf="disCol.header !== 'Status' && disCol.header !== 'Action'"
                    src="../../../../../assets/img/icons/filter_funnel.svg" class="img-fluid filter-funnel-icon" /> -->
            </th>

            <td mat-cell *matCellDef="let element">
                <span *ngIf="!disCol.isButton; else button" ngClass={{getClass(disCol.cell(element))}}>
                    <span *ngIf="disCol.header.toLowerCase().includes('date') "> {{ disCol?.cell(element)| date:
                        'MM/dd/yyyy h:mm a' }}</span>
                    <span *ngIf="!(disCol.header.toLowerCase().includes('date') )"> {{ disCol?.cell(element)}}</span>
                </span>
                <ng-template #button>
                    <button type="button" class="btn btn-action"
                        [disabled]="element?.currentStatus === 'Pending' || element?.currentStatus === 'Rejected'">
                        {{ disCol.cell(element) }}
                    </button>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="mat-row no-record-text" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                {{globalConstants.NO_RECORD_FOUND_TABLE}}
            </td>
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- <mat-paginator class="table-pagination" (click)="checkEvent()" [pageSizeOptions]="[2, 4, 6]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator> -->
</div>